// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"2df75213","177":"5de961fb","284":"4d6acf45","392":"e5d70fc8","442":"51e983a1","584":"ef9df394","634":"e6d967d7","982":"5cc72619"}[chunkId] + ".chunk.js";
};